declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { HCPService } from '../../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { AppData } from '../../../../models/appdata';
import { DBOperation } from '../../../../enums/enum';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { ActorDocRenewAlertsRequest, ActorDocRenewAlertsInfoController } from '../../../../models/docs/doc.model';
import { DOCService } from '../../../../services/doc.service';

@Component({
  selector: 'docrenewalertsinfo',
  templateUrl: './docrenewalertsinfo.component.html',
  styleUrls: ['./docrenewalertsinfo.component.scss']
})

export class DocRenewAlertsInfoComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  public isRequesting: boolean = false;

  CurrentActorDocRenewAlertsRequest: ActorDocRenewAlertsRequest;
  CurrentActorDocRenewAlertsInfoController: ActorDocRenewAlertsInfoController[];

  public ApiResData: ApiResponseModel;
  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private docservice: DOCService,
    private modalService: NgbModal) { }

  ngOnInit() {

    this.CurrentActorDocRenewAlertsRequest = new ActorDocRenewAlertsRequest();
    this.CurrentActorDocRenewAlertsInfoController = new Array<ActorDocRenewAlertsInfoController>();
    this.CurrentActorDocRenewAlertsRequest.ActorCode = this.ActorCode;
    this.CurrentActorDocRenewAlertsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.GetActorDocRenewAlertsInfoController();

  }

  GetActorDocRenewAlertsInfoController() {
    this.StartRefreshing();
    this.docservice.GetActorDocRenewAlertsInfoController(this.CurrentActorDocRenewAlertsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentActorDocRenewAlertsInfoController = this.ApiResData.Result;
         

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }





  isREADONLY: boolean = false;
  exportFileName: string = "docrenewalertInfoList_";
  dbops: DBOperation;
  columns: any[] = [
    {
      display: 'Credential Type',
      variable: 'CredentialTypeName',
      filter: 'text',
    },
    //{
    //  display: 'Renewal Type',
    //  variable: 'RenewalType',
    //  filter: 'text'
    //}
    //,
    {
      display: 'Alert Level',
      variable: 'AlertLevel',
      filter: 'text'
    }
    ,
    {
      display: 'Message',
      variable: 'DocRenewMessage',
      filter: 'text'
    }

  ];
  sorting: any = {
    column: 'ActorCredentialCode',
    descending: false
  };


 

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
